import { render, staticRenderFns } from "./ArrayBox.vue?vue&type=template&id=09e52f6e&scoped=true&"
import script from "./ArrayBox.vue?vue&type=script&lang=js&"
export * from "./ArrayBox.vue?vue&type=script&lang=js&"
import style0 from "./ArrayBox.vue?vue&type=style&index=0&id=09e52f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e52f6e",
  null
  
)

export default component.exports